import React, { Component } from 'react';
import About from './Pages/About';
import Work from './Pages/Work';
import './Pages/App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import ReactCSSTransitionReplace from 'react-css-transition-replace';

class RouterIndex extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <Route render={({ location }) => (
            <ReactCSSTransitionReplace
              transitionName="cross-fade"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              <div key={location.pathname}>
                <Switch location={location}>
                  <Route path="/" exact component={Work} />
                  <Route path="/about" component={About} />
                  <Route path="/work" component={Work} />
                </Switch>
              </div>
            </ReactCSSTransitionReplace>
          )} />
        </div>
      </BrowserRouter>

    );
  }
}

export default RouterIndex;



// WEBPACK FOOTER //
// ./src/Route.js